import React from 'react'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import { Separator } from 'components/ui/separator'

export interface PartnerCardProps {
	name: string
	title: string
	companyName: string
	className?: string
	actions?: any
	avatarUrl?: string
	bannerUrl?: string
}

export const PartnerCard = ({
	className = '',
	actions,
	name,
	title,
	companyName,
	avatarUrl,
	bannerUrl,
}: PartnerCardProps) => {
	const clip = (text: string) => text.length > 25 ? text.slice(0, 22) + '...' : text

	return (
		<div
			data-testid="PartnerCard"
			className={`bg-white rounded-lg border border-gray-200 shadow-sm flex flex-col overflow-hidden h-[260px] ${className}`}
		>
			{/* Banner */}
			<div
				className="h-16 w-full"
				style={{
					background: bannerUrl
						? `url(${bannerUrl}) center/cover no-repeat`
						: 'linear-gradient(135deg, #0080fe 0%, #00b4d8 100%)',
				}}
			/>

			{/* Avatar — overlaps the banner */}
			<div className="flex justify-center -mt-10">
				<Avatar className="h-24 w-24 shadow-sm">
					<AvatarImage src={avatarUrl} alt={name} />
					<AvatarFallback className="text-2xl font-semibold bg-gray-100 text-gray-600">
						{name ? name.charAt(0).toUpperCase() : '?'}
					</AvatarFallback>
				</Avatar>
			</div>

			{/* Info */}
			<div className="flex-1 flex flex-col items-center text-center px-4 pt-2 pb-3">
				<h3 className="text-sm font-semibold text-gray-900 max-w-full">{clip(name)}</h3>
				{title && <p className="text-xs text-gray-500 max-w-full mt-0.5">{clip(title)}</p>}
				{companyName && <p className="text-xs text-gray-400 max-w-full mt-0.5">{clip(companyName)}</p>}
			</div>

			{/* Action */}
			{actions && (
				<div className="mt-auto">
					<Separator className="bg-gray-200" />
					<div className="flex items-center justify-center px-4 py-3">
						{actions}
					</div>
				</div>
			)}
		</div>
	)
}

export default PartnerCard
